import React, { Component } from 'react';
import _ from 'lodash';
import { Switch, Redirect } from "react-router-dom";
import PrivateRoute from 'containers/PrivateRoute';

class ModalSwitch extends Component {
  previousLocation = this.props.location;

  componentWillUpdate(nextProps) {
    const { location } = this.props;
    // set previousLocation if props.location is not modal
    if (
      nextProps.history.action !== "POP" &&
      (!location.state || !location.state.modal)
    ) {
      this.previousLocation = this.props.location;
    }
  }

  render() {
    const { modalPath, modal: ModalComponent, location, routes } = this.props;
    const isModal = !!(
      location.state &&
      location.state.modal &&
      this.previousLocation !== location
    ); // not initial render
    return (
      <div className='modal-switch-container'>
        <Switch location={isModal ? this.previousLocation : location}>
          { _.map(routes, ({...rest, path, component: Component}) => {
            return <PrivateRoute key={path} path={path} component={Component} {...rest}/>
          })}
        </Switch>
        {isModal && <PrivateRoute path={modalPath} component={ModalComponent} />}
        {!isModal && location.pathname === modalPath && <Redirect to={'/app'} />}
      </div>
    );
  }
}

export default ModalSwitch;



// WEBPACK FOOTER //
// ./src/components/ModalSwitch.js